import { Panel } from 'primereact/panel';
import React, { useEffect, useState } from 'react';

import DisputeNeedsReviewPillstatus from '../../../assets/DisputeNeedsReviewPillstatus.png';
import DisputeReviewedPillStatus from '../../../assets/DisputeReviewedPillStatus.png';
import { MetricPayoutTable } from '../../../components/metricPayoutTable/MetricPayoutTable';
import { PillStatus } from '../../../components/pillsStatus/PillStatus';
import { useGetTeamLeadPayoutDataQuery } from '../../../pages/scorecardDashboard/scorecardDashboardSlice';
import { ConstApprovalWindowStatus, ConstPayoutApprovalStatus, ConstReviewStatus } from '../../../utils/typeConstants';
import { ScorecardPizzaTracker } from '../../../components/scorecardPizzaTracker/ScorecardPizzaTracker';

const payoutTableColumns = [
    { id: 1, name: 'Agent', field: 'employee_name', filter: true, template: 'agentNameBodyTemplate' },
    {
        id: 2,
        name: 'Metrics Attained',
        field: 'total_metrics_attained',
        filter: true,
        template: 'metricsMetBodyTemplate',
    },
    { id: 3, name: 'Metrics Reported', field: 'total_metrics_reported', filter: true, template: '' },
    { id: 4, name: 'Payout Amount', field: 'payout', filter: true, template: 'priceBodyTemplate' },
    { id: 5, name: 'Overall Status', field: 'approval_status_name', filter: true, template: '' },
    { id: 6, name: 'Agent Status', field: 'agent_status_name', filter: true, template: '' },
    { id: 7, name: 'Teamlead Status', field: 'tl_status_name', filter: true, template: '' },
];

const payoutsFilterColumns = ['employee_name', 'total_metrics_attained', 'total_metrics_reported', 'payout'];

interface PropTypes {
    empNum?: number;
    primaryApprovalWindowData?: [];
    inputyear: any;
    inputmonth: any;
    scorecardVersion?: number;    
}

const TeamPayout = ({ empNum, primaryApprovalWindowData, inputyear, inputmonth, scorecardVersion }: PropTypes) => {
    const [teamPayoutPillStatusDetails, setTeamPayoutPillStatusDetails] = useState({ status: '', icon: '', tooltip: '', bgColor: '' });;
    const [primaryApprovalWindowDataValue, setPrimaryApprovalWindowDataValue] = useState<any>([]);
    const [currentApprovalWindowStatus, setCurrentApprovalWindowStatus] = useState(0);

    const { data: teamPayoutData } = useGetTeamLeadPayoutDataQuery(
        {
            employeenumber: empNum,
            year: inputyear,
            month: inputmonth,
            scorecardVersionId: scorecardVersion,
        },
        { skip: !empNum || !inputyear || !inputmonth || !scorecardVersion}
    );

    useEffect(() => {
        setPrimaryApprovalWindowDataValue(primaryApprovalWindowData);
        if (primaryApprovalWindowDataValue?.data?.length > 0) {
            setCurrentApprovalWindowStatus(
                primaryApprovalWindowDataValue?.data[0]?.approval_window_status_id
            );
        }
    }, [primaryApprovalWindowDataValue, primaryApprovalWindowData]);

    useEffect(() => {
        if (teamPayoutData?.data) {
            const reviewStatusses: number[] = Array.from(
                new Set(teamPayoutData?.data.map((item: any) => item.review_status_id))
            );
            const tlApprovalStatusses: number[] = Array.from(
                new Set(teamPayoutData?.data.map((item: any) => item.tl_status_id))
            );
            if (primaryApprovalWindowDataValue && primaryApprovalWindowDataValue.data?.length > 0) {
                if (
                    primaryApprovalWindowDataValue?.data[0]?.approval_window_status_id === ConstApprovalWindowStatus.ASSOCIATE_WINDOW ||
                    primaryApprovalWindowDataValue?.data[0]?.approval_window_status_id === ConstApprovalWindowStatus.TEAM_LEAD_WINDOW
                ) {
                    if (
                        tlApprovalStatusses?.length === 1 &&
                        tlApprovalStatusses?.includes(ConstPayoutApprovalStatus.APPROVED)
                    ) {
                        setTeamPayoutPillStatusDetails({
                            status: 'Approved',
                            bgColor: '#64d96e',
                            icon: '',
                            tooltip: '',
                        });
                    } else if (
                        reviewStatusses?.length > 0 &&
                        reviewStatusses?.includes(ConstReviewStatus.DISPUTED)
                    ) {
                        setTeamPayoutPillStatusDetails({
                            status: 'Disputed',
                            icon: DisputeNeedsReviewPillstatus,
                            tooltip:
                                ' You can resolve disputes for Agents. Agents then need to review the resolved metrics.',
                            bgColor: '',
                        });
                    } else if (
                        reviewStatusses?.length > 0 &&
                        reviewStatusses?.includes(ConstReviewStatus.NEEDS_REVIEW)
                    ) {
                        setTeamPayoutPillStatusDetails({
                            status: 'Urgent',
                            icon: DisputeNeedsReviewPillstatus,
                            tooltip:
                                ' Request Agents immediately review their metrics to avoid delay for the whole team.',
                            bgColor: '',
                        });
                    } else {
                        setTeamPayoutPillStatusDetails({
                            status: 'Ready for Approval',
                            bgColor: '#64d96e',
                            icon: DisputeReviewedPillStatus,
                            tooltip: ' Thanks for reviewing your metrics.',
                        });
                    }
                } else if (primaryApprovalWindowDataValue?.data[0]?.approval_window_status_id !== ConstApprovalWindowStatus.TEAM_LEAD_WINDOW) {
                    setTeamPayoutPillStatusDetails({
                        status: 'In Progress',
                        bgColor: '#64d96e',
                        icon: DisputeNeedsReviewPillstatus,
                        tooltip: ' Month in Progress.',
                    });
                }
            } else setTeamPayoutPillStatusDetails({ status: '', tooltip: '', icon: '', bgColor: '' });
        } else setTeamPayoutPillStatusDetails({ status: '', tooltip: '', icon: '', bgColor: '' });
    }, [teamPayoutData, primaryApprovalWindowDataValue]);

    return (
        <Panel
            header="Team Payout"
            toggleable collapsed
            className="card mt-4 shadow bg-body rounded border-0"
            headerTemplate={(options) =>
                
                PillStatus({ options,  Headertext:'Team Payout' , pillDetails:teamPayoutPillStatusDetails })
            }
        >
            <ScorecardPizzaTracker
                inputYear={inputyear}
                inputMonth={inputmonth}
                inputScorecardVersion={scorecardVersion}
            />

             {teamPayoutData?.data.length > 0 ? (
                <MetricPayoutTable
                    data={teamPayoutData?.data}
                    scorecardroleid={1}
                    columns={payoutTableColumns}
                    uniqueKey="key"
                    filterColumns={payoutsFilterColumns}
                    currentApprovalWindow={currentApprovalWindowStatus}
                    approvalGrid="TeamPayout"
                />
            ) : (
                <div className="card mt-3 ms-1 me-1 shadow bg-body rounded border-0">
                    <div className="card-body p-0 pe-5 ps-4 align-middle text-center">
                        <div className="row" style={{ height: '15vh' }}>
                            <div className="col-md-12" style={{ margin: 'auto', paddingTop: '10px' }}>
                                <p className="align-middle">No results found for Team Payouts.</p>
                                <p>Try adjusting the month</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Panel>
    );
};

export default TeamPayout;
